import { DATE_FORMAT, DATETIME_FORMAT } from "@/config"

export default {
    data() {
        return {
            dateFormat: DATE_FORMAT,
            datetimeFormat: DATETIME_FORMAT
        };
    }
}